import Client from "../Client";

const controllers = {};

export function getController(baseClass, ...args) {
    const accountId = Client.account?.id;
    const id = JSON.stringify({ a: accountId, args: [baseClass.name, ...args]});
    if(id in controllers) return controllers[id];
    else {
        const controller = new baseClass(...args);
        controller.initialize();
        controllers[id] = controller;

        // The maximum duration for cached controllers is 15 seconds
        setTimeout(() => { delete controllers[id] }, 15*1000);
        return controller;
    }
}

export function getControllerUncached(baseClass, ...args) {
    const controller = new baseClass(...args);
    controller.initialize();
    return controller;
}